import { render, staticRenderFns } from "./making_quiz.vue?vue&type=template&id=97632b2c&scoped=true&"
import script from "./making_quiz.vue?vue&type=script&lang=js&"
export * from "./making_quiz.vue?vue&type=script&lang=js&"
import style0 from "./making_quiz.vue?vue&type=style&index=0&id=97632b2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97632b2c",
  null
  
)

export default component.exports